module.exports = {"legend":{"position":"none"},"backgroundColor":"transparent","titleTextStyle":{"color":"#2e038c","fontSize":14,"bold":false,"fontName":"Raleway"},"hAxis":{"textStyle":{"color":"#2e038c","fontSize":14,"bold":false,"fontName":"Raleway"}},"vAxis":{"textStyle":{"color":"#2e038c","fontSize":14,"bold":false,"fontName":"Raleway"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json-resources/chart-options.json
// module id = hJN8
// module chunks = 0